"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.IconTooltip = exports.HelpTooltip = exports.CustomIconTooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _uuid = require("uuid");
var _Fade = _interopRequireDefault(require("@mui/material/Fade"));
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _theme = _interopRequireDefault(require("./theme"));
var _internalTypography = require("../../internal/internal-typography");
var _constants = require("../../utils/constants");
var _tooltip_question_icon = _interopRequireDefault(require("./tooltip_question_icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledMuiTooltipWrapper = _styledComponents["default"].span.attrs(function () {
  return {
    excludeSpacingReset: true
  };
}).withConfig({
  displayName: "tooltips__StyledMuiTooltipWrapper"
})(["& .MuiTooltip-tooltip.MuiTooltip-tooltip{", ";display:inline-block;color:", ";background-color:", ";border:none;border-radius:0.3125rem;box-shadow:0 2px 6px ", ";box-sizing:border-box;font-size:1rem;padding:", ";white-space:normal;", " overflow-wrap:break-word;width:fit-content;z-index:", ";}"], _internalTypography.bodyStyles, function (_ref) {
  var $theme = _ref.$theme;
  return $theme.color;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.backgroundColor;
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.boxShadowColor;
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.padding;
}, function (_ref5) {
  var $label = _ref5.$label;
  return typeof $label == 'string' && 'max-width: 12.5rem;';
}, _constants.Z_INDEX_MAP.tooltip);
var TriggerWrapper = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__TriggerWrapper"
})(["display:inline-flex;"]);
var FlexContainer = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__FlexContainer"
})(["display:flex;"]);
function generateId() {
  return "tooltip-".concat((0, _uuid.v4)());
}
var ThemeableTooltip = function ThemeableTooltip(props) {
  var children = props.children,
    label = props.label,
    ariaLabel = props.ariaLabel,
    theme = props.theme;
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isVisible = _React$useState2[0],
    setIsVisible = _React$useState2[1];
  var id = React.useMemo(generateId, []);
  return /*#__PURE__*/React.createElement(StyledMuiTooltipWrapper, {
    $theme: theme,
    $label: label
  }, /*#__PURE__*/React.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/React.createElement(_Tooltip["default"], {
    PopperProps: {
      disablePortal: true
    },
    id: id,
    TransitionComponent: _Fade["default"],
    title: label || '',
    "aria-label": ariaLabel,
    open: isVisible,
    onClose: function onClose() {
      return setIsVisible(false);
    },
    onOpen: function onOpen() {
      return setIsVisible(true);
    }
  }, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(TriggerWrapper, (0, _extends2["default"])({
    "data-state": isVisible ? 'tooltip-visible' : 'tooltip-hidden'
  }, (0, _constants.getDataProvidesProps)(props)), children)))));
};
var Tooltip = exports.Tooltip = function Tooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip["default"]
  }), props.children);
};
Tooltip.defaultProps = {
  'data-provides': 'tooltip'
};
var IconTooltip = exports.IconTooltip = function IconTooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip.icon
  }), /*#__PURE__*/React.createElement(props.icon));
};
IconTooltip.defaultProps = {
  'data-provides': 'icon-tooltip'
};
var CustomIconTooltip = exports.CustomIconTooltip = function CustomIconTooltip(props) {
  return /*#__PURE__*/React.createElement(ThemeableTooltip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].tooltip.icon
  }), props.children);
};
CustomIconTooltip.defaultProps = {
  'data-provides': 'icon-tooltip'
};
var HelpTooltipTriggerWrapper = _styledComponents["default"].span.withConfig({
  displayName: "tooltips__HelpTooltipTriggerWrapper"
})(["display:flex;"]);
var FocusAwayListener = function FocusAwayListener(_ref6) {
  var children = _ref6.children,
    onFocusAway = _ref6.onFocusAway;
  var onBlur = function onBlur(event) {
    var outsideElementGainedFocus = event.relatedTarget instanceof Node && !event.currentTarget.contains(event.relatedTarget);
    var noElementGainedFocus = !event.relatedTarget;
    if (outsideElementGainedFocus || noElementGainedFocus) {
      onFocusAway();
    }
  };
  var onEscape = function onEscape(event) {
    if (event.key === 'Escape') {
      onFocusAway();
    }
  };
  return /*#__PURE__*/React.createElement("span", {
    onKeyDown: onEscape,
    onBlur: onBlur
  }, children);
};
var HelpTooltip = exports.HelpTooltip = function HelpTooltip(props) {
  var label = props.label,
    ariaLabel = props.ariaLabel;
  var _React$useState3 = React.useState(false),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    isVisible = _React$useState4[0],
    setIsVisible = _React$useState4[1];
  var id = React.useMemo(generateId, []);
  return /*#__PURE__*/React.createElement(StyledMuiTooltipWrapper, {
    $theme: _theme["default"].tooltip["default"],
    $label: label
  }, /*#__PURE__*/React.createElement(FocusAwayListener, {
    onFocusAway: function onFocusAway() {
      return setIsVisible(false);
    }
  }, /*#__PURE__*/React.createElement(_ClickAwayListener["default"], {
    onClickAway: function onClickAway() {
      return setIsVisible(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    role: "presentation"
  }, /*#__PURE__*/React.createElement(_Tooltip["default"], {
    PopperProps: {
      disablePortal: true,
      // Keep the tooltip mounted when it's not visible so that the aria-describedby reference always points
      // an existing element.
      keepMounted: true
    },
    id: id,
    TransitionComponent: _Fade["default"],
    open: isVisible,
    disableHoverListener: true,
    disableTouchListener: true,
    title: label || '',
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(HelpTooltipTriggerWrapper, (0, _extends2["default"])({
    "aria-describedby": id,
    "data-state": isVisible ? 'tooltip-visible' : 'tooltip-hidden',
    onClick: function onClick() {
      return setIsVisible(true);
    },
    onFocus: function onFocus() {
      return setIsVisible(true);
    }
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(_tooltip_question_icon["default"], null)))))));
};
HelpTooltip.defaultProps = {
  'data-provides': 'help-tooltip'
};